import { render, staticRenderFns } from "./CampaignsTable.vue?vue&type=template&id=61bba192&scoped=true&"
import script from "./CampaignsTable.vue?vue&type=script&lang=js&"
export * from "./CampaignsTable.vue?vue&type=script&lang=js&"
import style0 from "./CampaignsTable.vue?vue&type=style&index=0&id=61bba192&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bba192",
  null
  
)

export default component.exports